import {
  cryptorsControllerGetQuiz,
  quizAdminControllerDeleteOne,
  quizAdminControllerUpdateOne,
  quizControllerCreateQuiz,
  type Quiz,
  type UpdateQuiz,
  unwrapApiResponse,
} from "@cryptors/api-client";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const getQuiz = async (cryptorId: number): Promise<Quiz> =>
  unwrapApiResponse(
    cryptorsControllerGetQuiz<true>({
      path: { id: cryptorId },
      throwOnError: true,
    }),
  );

export const useGetQuiz = (cryptorId: number) => {
  return useQuery({
    enabled: !!cryptorId,
    queryKey: ["cryptors", "quiz", cryptorId],
    queryFn: () => getQuiz(cryptorId),
  });
};

const patchQuiz = async ({ id, data }: { id: number; data: UpdateQuiz }) => {
  return unwrapApiResponse(
    quizAdminControllerUpdateOne<true>({
      body: data,
      path: { id: String(id) },
      throwOnError: true,
    }),
  );
};

export const usePatchQuiz = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["quiz"],
    mutationFn: patchQuiz,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["cryptors", "quiz"],
      });
    },
  });
};

const deleteQuiz = async (id: number) => {
  await unwrapApiResponse(
    quizAdminControllerDeleteOne<true>({
      path: { id: String(id) },
      throwOnError: true,
    }),
  );
};

export const useDeleteQuiz = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["quiz"],
    mutationFn: deleteQuiz,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["cryptors", "quiz"],
      });
    },
  });
};

const postQuiz = async (cryptorId: number) => {
  return unwrapApiResponse(
    quizControllerCreateQuiz<true>({
      path: { id: cryptorId },
      throwOnError: true,
    }),
  );
};

export const usePostQuiz = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["quiz"],
    mutationFn: postQuiz,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["cryptors", "quiz"],
      });
    },
  });
};
